import React, { useEffect, useState } from 'react';

const Archieve = () => {
    const [groupedIssues, setGroupedIssues] = useState({});
    const articlePdfLink = '/uploads/manuscripts/';

    // Slugify helper to create valid HTML id from category
    const slugify = (text) =>
        text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

    // Fetch published articles and group them by category
    useEffect(() => {
        const fetchPublishedArticles = async () => {
            try {
                const response = await fetch('https://backend.impactjournal.co.in/manuscript/archive');
                const data = await response.json();

                const grouped = {};
                data.forEach(article => {
                    if (!grouped[article.articleCategory]) {
                        grouped[article.articleCategory] = [];
                    }
                    grouped[article.articleCategory].push(article);
                });

                setGroupedIssues(grouped);
            } catch (error) {
                console.error("Error fetching published articles:", error);
            }
        };

        fetchPublishedArticles();
    }, []);

    // Scroll to hash ID if present in URL
    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            setTimeout(() => {
                const element = document.querySelector(hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 300); // Optional delay for animation/layout
        }
    }, []);

    const handleDownloadCertificate = () => {
        window.location.href = '/download-certificate';
    };

    return (
        <div className="about-ed-wrapper-impact">
            <h2 className="about-ed-heading-impact">Archive  Issues</h2>

            {Object.keys(groupedIssues).length === 0 ? (
                <h3 style={{ textAlign: "center", marginTop: "2rem" }}>
                    No archive issues available.
                </h3>
            ) : (
                Object.entries(groupedIssues).map(([category, issues], categoryIndex) => (
                    <div key={categoryIndex} className="about-ed-block-impact" id={slugify(category)}>
                        <div className="about-ed-role-impact">{category}</div>
                        <div className="about-ed-content-impact">
                            <div className="current-issues-cards-impact">
                                {issues.map((issue, issueIndex) => (
                                    <div className="current-issue-card-impact" key={issueIndex}>
                                        <div className="current-issue-card-right-impact">
                                            <div className="current-issue-card-article-title">
                                                <h3>{issue.articleTitle}</h3>
                                            </div>
                                            <div className="current-issue-card-person-name">
                                                <p>{issue.name}</p>
                                            </div>
                                            <div className="current-issue-card-buttons">
                                                <a
                                                    href={`https://backend.impactjournal.co.in/uploads/manuscripts/${issue.file}`}
                                                    download
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="download-current-issue-article"
                                                >
                                                    Download article
                                                </a>
                                                <a
                                                    onClick={handleDownloadCertificate}
                                                    className="download-current-issue-certificate"
                                                >
                                                    Download certificate
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default Archieve;
